import { STATS } from "../../data/site";
import { Counter, Reveal } from "../motion";

export const Stats = () => (
  <section aria-label="Alcuni numeri" data-testid="stats-section" className="border-b border-[color:var(--ngp-line)] bg-[color:var(--ngp-paper)]">
    <div className="mx-auto max-w-[1440px] px-5 py-20 sm:px-8 lg:px-12 lg:py-28">
      <Reveal><p className="eyebrow text-[color:var(--ngp-teal-ink)]">Alcuni numeri</p></Reveal>
      <div className="mt-10 grid grid-cols-2 gap-y-12 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08} className={`pr-4 ${i % 2 === 1 ? "border-l border-[color:var(--ngp-line)] pl-5" : ""} ${i > 0 ? "lg:border-l lg:border-[color:var(--ngp-line)] lg:pl-8" : ""}`}>
            <p className="font-display text-5xl font-semibold leading-none tracking-[-0.04em] sm:text-6xl lg:text-7xl xl:text-8xl">
              <Counter value={s.value} testId={`stat-value-${i + 1}`} />
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm font-medium text-[color:var(--ngp-muted)]">
              <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--ngp-teal)]" aria-hidden="true" />{s.label}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
